<template>
  <!-- 销售订单中待送订单、待确认订单打印 -->
  <div v-loading="loading">
    <el-row class="tac" type="flex">
      <el-col :span="24" class="layout-header">
        <div class="layout-header-logo">
          <img :src="lkdLogo" style="height: 50px;margin-top: 5px">
        </div>
        <span style="margin-right: 150px;color: white">打印预览&nbsp;&nbsp;<i class="el-icon-close" @click="back"
            style="color: white"></i></span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="4" style="margin-top: 20px">
        <h4 style="text-align: center">打印预览</h4>
      </el-col>
      <el-col :span="2" :offset="14" style="margin-top: 20px">
        <i class="el-icon-close" @click="back"></i>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
    <div id="subOutputRank-print" style="margin: auto">
      <template v-for="item in tableData">
        <v-tax :tableData="item" :key="item.ORDER_DETAIL_ID" :headerData="topData" :manager="managername"
          :supplier="printName" :ASSOCIATED_PERSON="ASSOCIATED_PERSON"></v-tax>
      </template>
    </div>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { notOrderDetailFun, updatePrintOrderFun, updatePrintTimeFun } from 'api/sellOrder';
import VTax from '@/components/orderPrint/sellOrderFivePrintTax';

export default {
  data() {
    return {
      loading: true,
      managername: sessionStorage.getItem('name'),
      tableData: [],
      topData: [],
      printName: sessionStorage.getItem('supplierName'),
      printLength: 30,
      pageRouter: sessionStorage.getItem('pageRouter'),
      isremarks: this.$route.params.remarks,
      ASSOCIATED_PERSON: [],
      isThirdParty: this.$route.params.isThirdParty,
      lkdLogo: this.$util.publicLogo() || '',
    };
  },
  components: {
    VTax,
  },
  created() {
    this.queryOrderDetailListData();
  },
  methods: {
    back() {
      window.history.go(-1);
    },
    queryOrderDetailListData() {
      const params = {
        ID: sessionStorage.getItem('orderId'),
      };
      if (this.isThirdParty) {
        params.Supplier_Third_Type = 1;
        params.FILTER_FLAG = 0;
        params.GYS_ID = sessionStorage.getItem('tcId');
      }
      notOrderDetailFun(params)
        .then((result) => {
          if (result[0].TITLE[0].AGENT) {
            sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
          } else {
            sessionStorage.setItem('AGENT', 0);
          }
          let res = [];
          this.ASSOCIATED_PERSON = result[0].ASSOCIATED_PERSON;
          res = result.length > 0 ? result[0].DETAIL : [];
          for (let i = 0; i < res.length; i++) {
            res.forEach((item, index) => {
              item.ID = index + 1;
            });
          }
          this.topData.push(...result[0].TITLE);
          this.topData[0].ORDER_ID = sessionStorage.getItem('orderId');
          this.loading = false;
          const len = res.length;
          this.printLength = 35;
          const n = this.printLength; // 假设每行显示4个
          const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1);
          const data = [];
          let totalSupplierFee = 0;
          for (let i = 0; i < lineNum; i++) {
            data.push(res.slice(i * n, i * n + n));
          }
          data.forEach((item, index) => {
            totalSupplierFee = 0;
            item.forEach((itemTwo) => {
              totalSupplierFee += Number(itemTwo.PROJECT_TOTAL_FEE);
            });
            item.currentPage = index + 1;
            item.totalPage = lineNum;
            item.pageFee = Math.round(totalSupplierFee * 100) / 100;
          });
          this.tableData = data;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 打印
    printPreview() {
      if (this.topData[0].STATUS == 1 || this.topData[0].STATUS == 2) {
        const data = {
          ORDER_ID: Number(sessionStorage.getItem('orderId')),
        };
          // 如果是待送订单需要改变订单状态
        updatePrintOrderFun(data)
          .then((res) => {
            this.$message.show({ text: '操作成功', type: 'success' });
            const subOutputRankPrint = document.getElementById('subOutputRank-print');
            const newContent = subOutputRankPrint.innerHTML;
            const oldContent = document.body.innerHTML;
            document.body.innerHTML = newContent;
            window.print();
            window.location.reload();
            document.body.innerHTML = oldContent;
            this.$router.push({ name: this.pageRouter });
            window.location.reload();
            return false;
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      } else {
        const params = {
          ORDER_ID: Number(sessionStorage.getItem('orderId')),
        };
        // 改变打印次数
        updatePrintTimeFun(params).then((result) => {
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
        // this.$router.push({ name: this.pageRouter})
        const subOutputRankPrint = document.getElementById('subOutputRank-print');
        const newContent = subOutputRankPrint.innerHTML;
        const oldContent = document.body.innerHTML;
        document.body.innerHTML = newContent;
        window.print();
        window.location.reload();
        document.body.innerHTML = oldContent;
        this.$router.push({ name: this.pageRouter });
        window.location.reload();
        return false;
      }
    },
  },
};
</script>
<style scoped>
.ma img {
  width: 105px
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

#subOutputRank-print {
  width: 284mm;
}

@media print {
  .page-break {
    page-break-after: always;
  }
}

.layout-header {
  z-index: 10;
  position: fixed;
  width: 100%;
  background: linear-gradient(#373737, #464C5B);
  line-height: 60px;
  text-align: right;
  border-bottom: 1px solid #505664;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.layout-header-logo {
  height: 60px;
  width: 210px;
  float: left;
}

.layout-header-logo img {
  width: 90%;
  margin-right: 5%;
  height: 60px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/sellOrderFivePrint.vue